import { render, staticRenderFns } from "./TransactionInfoAdmin.vue?vue&type=template&id=6a9b4135"
import script from "./TransactionInfoAdmin.vue?vue&type=script&lang=js"
export * from "./TransactionInfoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports